// Components
import { Input, InputGroup, Label } from "reactstrap"
import { ActionButton } from "components/buttons"

// Icons
import { TbMinus, TbPlus } from "react-icons/tb"

export const InputNumber = ({
	label = "",
	className = "",
	min = "",
	max = "",
	id = Math.random().toString(36).substring(2, 7),
	noMargin = false,
	noLabel = false,
	value,
	onChange,
	ref
}) => {
	// Variables
	const isMin = min && value <= parseInt(min)
	const isMax = max && value >= parseInt(max)

	const decrease = () => {
		if (isMin) {
		} else {
			onChange(parseInt(value ?? "0") - 1)
		}
	}

	const increase = () => {
		if (isMax) {
		} else {
			onChange(parseInt(value ?? "0") + 1)
		}
	}

	return (
		<div className={`${noMargin ? 'mb-0' : 'mb-1'} ${className}`}>
			{!noLabel && (
				<Label className='fw-bold' for={`inputNumber-${id}`}>
					{label}
				</Label>
			)}

			<InputGroup style={{ width: 100 }}>
				<ActionButton type="button" className="px-50" color={isMin ? "secondary" : "primary"} size="sm" disabled={isMin} onClick={decrease}>
					<TbMinus color="white" size={10} />
				</ActionButton>

				<Input readOnly type="text" bsSize="sm" ref={ref} className="text-center" id={`inputNumber-${id}`} value={value} />

				<ActionButton type="button" className="px-50" color={isMax ? "secondary" : "primary"} size="sm" disabled={isMax} onClick={increase}>
					<TbPlus color="white" size={10} />
				</ActionButton>
			</InputGroup>
		</div>
	)
}
